import axios from 'axios'

function createHttpClient({ csrfToken = '', env = '' }) {
  const config = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': csrfToken,
    },
  }

  if (window.location.hostname === 'localhost' && env === 'login-service') {
    config.baseURL = 'http://localhost:3004'
  }

  return axios.create(config)
}

export default createHttpClient
